import { DateUtil } from "@/calico-vue/service";

export * from "@/calico-vue/filters";

export function dateWithDow(value) {
  if (value == null) return null;
  return DateUtil.format(value, "YYYY/MM/DD(d)");
}
